import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Helper } from '../../../../pages/common/helper';
import { SecurityHelper } from '../../../../pages/common/securityHelper';

@Injectable({
  providedIn: 'root'
})
export class CustomChatService {

  constructor(
    private http: HttpClient
  ) { }

  IVIChatbot(userQuery: string, session_id: string) {
    let paramObject = {
      'message': userQuery,
      'session_id': session_id,
      'user_id': SecurityHelper.GetLoggedInUserData().userID
    }
    return this.http.post(Helper.API_URL() + '/api/Chat/IVIChatbot', paramObject);
  }

  IVIChatbotFeedback(session_id: string, message_id: string, rating: number, comment: string) {
    let paramObject = {
      'session_id': session_id,
      'message_id': message_id,
      'rating': rating,
      'comment': comment,
      'user_id': SecurityHelper.GetLoggedInUserData().userID
    }
    return this.http.post(Helper.API_URL() + '/api/Chat/IVIChatbotFeedback', paramObject);
  }
}
